import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import vtform_es from "./locales/es/vtform.json";
import vtform_en from "./locales/en/vtform.json";
import vtcart_es from "./locales/es/vtcart.json";
import vtcart_en from "./locales/en/vtcart.json";
import vtcartform_es from "./locales/es/vtcartform.json";
import vtcartform_en from "./locales/en/vtcartform.json";
import vtcartsummary_es from "./locales/es/vtcartsummary.json";
import vtcartsummary_en from "./locales/en/vtcartsummary.json";
import vtcartfinal_es from "./locales/es/vtcartfinal.json";
import vtcartfinal_en from "./locales/en/vtcartfinal.json";

i18next
  .use(initReactI18next)
  .init({
    supportedLngs:['en','es','de'],
    fallbackLng: 'es',
    resources: {
      es: {
        vtform : vtform_es,
        vtcart : vtcart_es,
        vtcartform : vtcartform_es,
        vtcartsummary : vtcartsummary_es,
        vtcartfinal : vtcartfinal_es
      },
      en: {
        vtform : vtform_en,
        vtcart : vtcart_en,
        vtcartform : vtcartform_en,
        vtcartsummary : vtcartsummary_en,
        vtcartfinal : vtcartfinal_en
      },
    },
  });

export default i18next;

/*translationStats: { // optional options, if not provided it will guess based on your i18next config
     queryStringParam: 'showtranslations',
     sourceLng: 'es',
     targetLngs: ['en', 'de'],
     preserveEmptyStrings: false
   }*/